/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PDFExportPanel from '../../../../../../../SharedModules/pdfExport/PDFExportPanel';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));

const NDCDetailsTab = (props) => {
  const classes = useStyles();
  const { tabValue, handleChangeTabValue } = props;

  const exportCSV = React.useCallback(() => {
    return props.gridApi.exportDataAsCsv({
      fileName: `${tabValue ? `${tabValue}.csv` : 'data.csv'}`,
    });
  }, [tabValue, props]);
  const exportExcel = React.useCallback(() => {
    return props.gridApi.getDataAsCsv();
  }, [tabValue, props]);
  const RedColor='#a81f00';


  return (
    <div className='tabs-wrapper d-flex justify-content-between'>
      <div data-testid='ndc-tabs' className={classes.root}>
        <AppBar position='static' sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color='red'
            style={{ color: RedColor }}
          >
            {props.tabData.map((item, index) => (
              <Tab
                key={index}
                tabIndex={0}
                style={{ textTransform: 'capitalize' }}
                value={item.value}
                label={item.label}
              />
            ))}
          </Tabs>
        </AppBar>
      </div>
    </div>
  );
};

export default NDCDetailsTab;
